import Vue from "vue";
import App from "./App.vue";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import vuetify from "./plugins/vuetify";
import "./components/index";
import store from "./store";
import router from "./route";
import "./utils/common.scss";
import "./plugins/vuescroll";
import i18n from "./plugins/i18n";
import "@babel/polyfill";
import md5 from "js-md5";
Vue.prototype.$md5 = md5;

Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#app");
